// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_oS-","cls2":"BulkFollowSuggestion-cls2_dDl BulkFollowSuggestion-cls1_oS-"};